<script setup lang="ts">
import FaqItem from "./FaqItem.vue"
</script>

<template>
    <div class="container">
        <div class="breadcrumb">
            <RouterLink class="breadcrumb-item" :to="{ name: 'home' }">Home</RouterLink>
            <div class="breadcrumb-item">FAQ</div>
        </div>
    </div>

    <div class="container mt-5">
        <h2>Häufig gestellte Fragen</h2>
        <h1>FAQ</h1>
    </div>

    <div class="container py-5">
        <FaqItem question="Wie kann ich bestellen?">
            Wenn du noch kein Kundenprofil bei uns hast, registriere dich bitte zunächst. Nach erfolgreicher
            Verifizierung als Cannabispatient kannst du über unseren Online-Shop bestellen. Gerne helfen wir dir auch
            telefonisch, per Mail oder vor Ort in Hamburg dabei, deine Bestellung über dein Kundenprofil zu erstellen.
        </FaqItem>

        <FaqItem question="Ich habe kein Rezept, kann ich trotzdem bestellen?">
            Natürlich kannst du bei uns deine Arzneimittel reservieren, wenn du erst noch zu deinem Arzt oder deiner
            Ärztin musst. Wir halten deine Reservierung 5 Werktage bereit (wenn nicht anders mit dir vereinbart) und
            bitten dich um entsprechende Kontaktaufnahme, wenn du dein Rezept in Händen hältst. Ohne gültiges Rezept
            kann selbstverständlich keine Abgabe erfolgen.
        </FaqItem>

        <FaqItem question="Was muss auf meinem Rezept stehen?">
            Bitte achte darauf, dass auf deinem Rezept die gewünschte Sorte und Menge exakt bezeichnet werden. Am Ende
            des Bestellprozesses findest du eine Auflistung wie die Verschreibung auszusehen hat.
        </FaqItem>

        <FaqItem question="Wie löse ich mein Rezept bei CANN24 ein?">
            Während des Bestellprozesses wirst du aufgefordert ein Bild deines Papierrezeptes hochzuladen. Der Upload
            kann auch zu einem späteren Zeitpunkt erfolgen. Anschließend sorge bitte dafür, dass uns dein
            Originalpapierrezept schnellstmöglich erreicht, denn bevor kein gültiges Original in der Apotheke vorliegt,
            kann deine Bestellung nicht bearbeitet werden. Beachte, dass es den gesamten Bearbeitungsprozess aber
            beschleunigen kann, wenn wir die Rezeptdaten bereits digital von dir zu Verfügung gestellt bekommen. Du
            kannst das Rezept selbstverständlich auch persönlich bei uns in der Apotheke abgeben. Wenn du einen
            E-Rezept-Ausdruck hast, kannst du diesen auch einfach hochladen, per Mail senden oder von deinem Arzt zu uns
            übertragen lassen. Das E-Rezept kann auch von deiner Versichertenkarte bei uns in der Apotheke abgerufen
            werden, wenn diese bei uns eingesteckt wird. Bitte beachte, dass uns stets ein gültiges Rezept vorliegen
            muss, um deine Bestellung bearbeiten zu können.
        </FaqItem>

        <FaqItem question="Wie kann ich bezahlen?">
            Patienten mit einer Kostenübernahme können ihren Rezeptanteil, sofern anfallend, auf Rechnung mit einem
            Zahlungsziel von 10 Tagen zahlen. Privatpatienten und Selbstzahler können ihre Bestellung per Vorkasse auf
            Rechnung bezahlen. In Einzelfällen ist eine individuelle Zahlungsvereinbarung möglich. Hierzu ist ein
            mindestens sechs Monate bestehendes und genutztes Kundenkonto ohne offene Forderungen Voraussetzung.
            Außerdem kannst du bei uns in der Apotheke bar oder mit Karte bezahlen.
        </FaqItem>

        <FaqItem question="Ich möchte über CANN24 bestellen, aber hole die Ware selbst ab. Geht das?">
            Natürlich! Einfach beim Check-Out angeben und wir freuen uns auf deinen Besuch.
        </FaqItem>

        <FaqItem question="Ich habe mich gerade registriert, aber kann noch nicht bestellen. Warum nicht?">
            Wir müssen dich erst freischalten. Dazu sichten wir deine Unterlagen, die du während der Registrierung
            hochladen musstest. Bitte gib uns dafür ein paar Stunden Zeit. Sobald du freigeschaltet bist, bekommst du
            automatisch eine Mail von uns und kannst loslegen.
        </FaqItem>

        <FaqItem question="Warum wollt Ihr so viele Unterlagen von mir?">
            Eine Verifizierung als Cannabispatient ist bei uns erforderlich, damit wir weiterhin für eine hohe
            Sicherheit im Rahmen deiner Belieferung sorgen können. Cannabispräparate bleiben auch ohne
            Betäubungsmittelstatus ein sensibles Produkt, bei dem wir sicherstellen wollen, dass die Identität unserer
            Kunden mit den Daten des Papier- oder E-Rezeptes übereinstimmen, nicht zuletzt auch, um den geforderten
            Kinder- und Jugendschutz unsererseits erfüllen zu können. Deine Unterlagen helfen uns aber auch, dich in die
            entsprechende Kundengruppe einzuordnen, damit du von allen Vorteilen profitieren kannst, die wir dir bieten
            wollen.
        </FaqItem>

        <FaqItem question="Liefert Ihr auch am selben Tag (Same-Day)?">
            Sind alle Voraussetzungen erfüllt, damit eine Versorgung stattfinden kann, so ist in Einzelfällen auch eine
            Same-Day-Belieferung möglich. Die Kosten müssen von dir getragen werden und können erheblich sein. Sprich
            uns bitte im Bedarfsfall direkt darauf an. Wir empfehlen dir, deine Bestellung einfach rechtzeitig zu
            tätigen und den entsprechenden zeitlichen Ablauf einzukalkulieren.
        </FaqItem>

        <FaqItem question="Ich finde mein gewünschtes Produkt nicht. Was nun?">
            Es ist nicht auszuschließen, dass einzelne Produkte nach ihrer Neueinführung erst einen Tag später im
            Online-Shop auftauchen, obwohl wir sie bereits in der Apotheke haben. Manchmal haben wir uns auch aufgrund
            mangelnder Nachfrage oder Nichteinhaltung unserer Qualitätsstandards gegen eine Lagerhaltung entschieden.
            Wenn du dein Produkt nicht findest, ruf uns an oder schreibe uns eine Mail. Wir werden versuchen, dich
            schnellstmöglich versorgen zu können.
        </FaqItem>

        <FaqItem question="Eine Frage hätte ich da noch…">
            Solltest du noch etwas wissen wollen, dann schreib uns am besten eine Mail an <b>support@cann24.de</b> oder
            ruf uns an. Wir helfen dir gerne.
        </FaqItem>
    </div>
</template>
